import { upload, get, remove, post } from "./api";

/**
 * Upload CSV file for import.
 * @param file - CSV file to upload
 * @param importId - Import session id
 * @param objectTypes - Comma-separated types, e.g. "SALE" or "CONTACT,COMPANY"
 */
export async function uploadCSV({
  file,
  importId = "",
  objectTypes = "CONTACT,COMPANY",
}: {
  file: File;
  importId?: string;
  objectTypes?: string;
}) {
  const params = new URLSearchParams({ importId, objectTypes });
  const uploadUrl = `/apps/import_csv/upload?${params.toString()}`;
  const data = new FormData();
  data.append("file", file);
  const response = await upload({ path: uploadUrl, data });
  return response.data;
}

export const getUploadImports = async (): Promise<any> => {
  const response = await get({ path: `/apps/import_csv/imports` });
  return response.data;
};

export const deleteImport = async (importId): Promise<any> => {
  const response = await remove({
    path: `/apps/import_csv/imports/${importId}`,
  });
  return response.data;
};

export const startImport = async (importId, importData): Promise<any> => {
  const response = await post({
    path: `/apps/import_csv/imports/${importId}/start`,
    data: importData,
  });
  return response.data;
};

/** Get import detail including file data from GET /api/apps/import_csv/imports/{importId} */
export const getImportCSVData = async (importId: string): Promise<any> => {
  const response = await get({ path: `/apps/import_csv/imports/${importId}` });
  const data = response.data;
  // Normalize: backend may return fileData (Import schema), map to csvText for consumers
  if (data && data.fileData != null && data.csvText == null) {
    return { ...data, csvText: data.fileData };
  }
  return data;
};
